import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo-left.png'
import _imports_1 from '../assets/images/centerLogo.png'
import _imports_2 from '../assets/images/logo-right.png'
import _imports_3 from '../assets/images/bomb.png'
import _imports_4 from '../assets/images/caution.png'
import _imports_5 from '../assets/images/bill.png'
import _imports_6 from '../assets/images/hacker.png'
import _imports_7 from '../assets/images/boss.png'


const _withScopeId = n => (_pushScopeId("data-v-4cd10c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modalInner" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"modalHeader\" data-v-4cd10c12><div class=\"leftLogo\" data-v-4cd10c12><img src=\"" + _imports_0 + "\" alt=\"\" data-v-4cd10c12></div><div class=\"centerLogo\" data-v-4cd10c12><img src=\"" + _imports_1 + "\" alt=\"\" data-v-4cd10c12></div><div class=\"rightLogo\" data-v-4cd10c12><img src=\"" + _imports_2 + "\" alt=\"\" data-v-4cd10c12></div></div>", 1)
const _hoisted_4 = { class: "modalContent with-bg" }
const _hoisted_5 = { class: "modalContentInner" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "red" }, [
  /*#__PURE__*/_createTextVNode("Level 1 (Icon to shoot "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "img",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(" )")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Myth "),
  /*#__PURE__*/_createTextVNode("– Public cloud is cheap compared to private cloud.")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Fact "),
  /*#__PURE__*/_createTextVNode(" – Public cloud resources can become very expensive, very quickly. Often the headline costs are a fraction of the costs you find yourself paying.")
], -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "modalFooterIn"
}
const _hoisted_12 = {
  key: 2,
  class: "info"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "red" }, [
  /*#__PURE__*/_createTextVNode("Level 2 (Icon to shoot – "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "img",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Myth "),
  /*#__PURE__*/_createTextVNode("– More security tools means more secure data.")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Fact "),
  /*#__PURE__*/_createTextVNode(" – This couldn’t be further from the truth. Complex environments with multiple tools and vendors is a recipe for high risk.")
], -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  class: "modalFooterIn"
}
const _hoisted_18 = {
  key: 4,
  class: "info"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "red" }, [
  /*#__PURE__*/_createTextVNode("Level 3 (Icon to shoot – "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "img",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Myth "),
  /*#__PURE__*/_createTextVNode("– Public cloud is easy to manage.")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Fact "),
  /*#__PURE__*/_createTextVNode(" – Your team will need to manage your organisation’s use of public cloud. This all comes at an additional cost in terms of time, tools and skilled resource.")
], -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 5,
  class: "modalFooterIn"
}
const _hoisted_24 = {
  key: 6,
  class: "info"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "red" }, [
  /*#__PURE__*/_createTextVNode("Level 4 (Icon to shoot – "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "img",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Myth "),
  /*#__PURE__*/_createTextVNode("– STaaS means not on my premises and therefore not secure.")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Fact "),
  /*#__PURE__*/_createTextVNode(" – Most MSPs invest heavily in top-end cybersecurity tools, as well as staff who are highly knowledgeable in their field.")
], -1))
const _hoisted_28 = [
  _hoisted_25,
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 7,
  class: "modalFooterIn"
}
const _hoisted_30 = {
  key: 8,
  class: "info"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "red" }, [
  /*#__PURE__*/_createTextVNode("Level 5 (Icon to shoot – "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "img",
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "One security advantage of hybrid cloud is the flexibility to decide where applications and data will reside, in a private cloud or datacentre.", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Need certain data to stay on-premise?", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Some STaaS offerings, such as Creative ITC’s, can also accommodate this.", -1))
const _hoisted_35 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 9,
  class: "modalFooterIn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.startLvl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.startLvl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-large btn-primary large-btn",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startGame && _ctx.startGame(...args)), ["prevent"]))
                    }, "STOP THE MONEY BOMBS")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.level == '1' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.level == '1' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-large btn-primary large-btn",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playGame && _ctx.playGame(...args)), ["prevent"]))
                    }, "REMOVE THE RISKS")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.level == '2' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_22))
                : _createCommentVNode("", true),
              (_ctx.level == '2' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-large btn-primary large-btn",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playGame && _ctx.playGame(...args)), ["prevent"]))
                    }, "BLAST THE BILLS")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.level == '3' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_28))
                : _createCommentVNode("", true),
              (_ctx.level == '3' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-large btn-primary large-btn",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playGame && _ctx.playGame(...args)), ["prevent"]))
                    }, "SECURE YOUR STORAGE")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.level == '4' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_35))
                : _createCommentVNode("", true),
              (_ctx.level == '4' && _ctx.startLvl==false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-large btn-primary large-btn",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playGame && _ctx.playGame(...args)), ["prevent"]))
                    }, "TAKE ON THE BOSS LEVEL")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}